import { Link, useLocation } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { useLang } from "@/i18n/LanguageProvider";
import { buildPath, matchPath } from "@/lib/routes";

// Sticky mobile Book CTA — large touch target (>=48px). Hidden on the booking page.
export function StickyBookCTA() {
  const { lang, t } = useLang();
  const { pathname } = useLocation();
  const match = matchPath(pathname);
  if (match && (match.page.key === "book" || match.page.key === "contact")) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 p-3 backdrop-blur md:hidden" data-testid="sticky-book-cta">
      <Link
        to={buildPath("book", lang)}
        data-testid="sticky-book-btn"
        className="flex h-[52px] w-full items-center justify-center gap-2 rounded-full bg-petrol text-[16px] font-semibold text-white"
      >
        <CalendarCheck className="h-5 w-5" strokeWidth={1.5} />
        {t("cta.book")}
      </Link>
    </div>
  );
}
